// extracted by mini-css-extract-plugin
export default {"menuBlock":"pG-z","title":"qG-z","nav":"rG-z","flexCell":"sG-z","facetLink":"tG-z"};